import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ContactUsButton from "./ReusableComponents/ContactUsButton";

const Container = styled.div``;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const Text = styled.p`
  font-size: 1.125rem;
  text-align: center;
  margin-bottom: 24px;
`;

const Telemedicine: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="Telemedicine">
      <Title>{t("whatWeDo.telemedicine.title").toUpperCase()}</Title>
      <Text>{t("whatWeDo.telemedicine.description")}</Text>
      <ContactUsButton label={t("whatWeDo.telemedicine.button")} />
    </Container>
  );
};

export default Telemedicine;
